const LOAD_DEPLOYS = (state, payload) => {
    state.deploys = payload;
};

export default {
    LOAD_DEPLOYS,
};
